
define('ldsh!modules/address/list/row', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '  \n  <td>\n   <span name="work_phone"></span>\n  </td>\n  \n  <td>\n   <span name="home_phone"></span>\n  </td>\n  \n  <td>\n   <span name="mobile"></span>\n  </td>\n  \n  <td>\n   <span name="fax"></span>\n  </td>\n  \n  <td>\n   <span name="notes"></span>\n  </td>\n  \n  <td>\n   <span name="street1"></span>\n  </td>\n  \n  <td>\n   <span name="street2"></span>\n  </td>\n  \n  <td>\n   <span name="city"></span>\n  </td>\n  \n  <td>\n   <span name="state"></span>\n  </td>\n  \n  <td>\n   <span name="pocode"></span>\n  </td>\n\n  <td>\n   \t\t<a href="javascript:;" class="edit-item">Edit</a>\n  </td>\n  <td>\n   \t\t<a href="javascript:;" class="delete-item">Delete</a>\n  </td>\n';

}
return __p
};});

